<mat-card>
    <mat-card-title>
        <span [translate]="'profilUser.accessibilite.title'"></span>
    </mat-card-title>

    <mat-card-content>
        <div #innerHtmlContainer class="inner-html" data-test-id="inner-html-container" [innerHTML]="accessibiliteHtml" (click)="onInnerHtmlClick($event)"></div>
    </mat-card-content>
</mat-card>